import { allFeaturesAtFalse } from './default';
export const features = {
    ...allFeaturesAtFalse,
    home: {
        ...allFeaturesAtFalse.home,
        advantages: true,
        anchors: [
            {
                label: 'Top catégories',
                selector: '#home-categories',
                hideLink: false,
            },
            {
                label: 'Nos marques',
                selector: '#home-brands',
                hideLink: false,
            },
            {
                label: 'Rejoindre aladin.farm',
                selector: '#home-why-aladin',
                hideLink: false,
            },
            {
                label: 'Produits',
                selector: '.recommended-products',
                hideLink: true,
            },
        ],
    },
    certificates: {
        phyto: true,
        explosive: true,
    },
    contact: {
        mailTo: 'contact@aladin.farm',
        hubspot: {
            formId: 'a370cba5-c60b-4888-affb-44fdfb7aeca6',
            portalId: '5942000'
        },
    },
    shoppingList: true,
    footer: {
        social: {
            facebook: 'https://www.facebook.com/aladin.farm.legeniedelagriculture',
            linkedin: 'https://www.linkedin.com/company/aladinfarm/about/',
            x: 'https://twitter.com/AladinFarm',
            youtube: 'https://www.youtube.com/channel/UC4vTNr_d29yRv0j1ulZHung',
        },
        sitemap: [
            {
                title: 'Mieux nous connaître',
                links: [
                    {
                        label: 'À propos de aladin.farm',
                        externalHref: 'https://info.aladin.farm/a-propos',
                    },
                    {
                        label: 'aladin.farm recrute',
                        externalHref: 'https://info.aladin.farm/offres-d-emploi',
                    },
                    {
                        label: 'Media / Presse',
                        externalHref: 'https://info.aladin.farm/media-presse',
                    },
                    {
                        label: 'Nos partenaires distributeurs',
                        internalTo: { name: 'partners' },
                    },
                    {
                        label: 'Nos marques fournisseurs',
                        internalTo: { name: 'brands' },
                        customClickEventFunction: 'goToOurBrand',
                    },
                    {
                        label: 'Actualités agricoles',
                        internalTo: { name: 'annuaire' },
                        customClickEventFunction: 'trackGotToArticleBook',
                    },
                ],
            },
            {
                title: 'Nos services',
                links: [
                    {
                        label: 'Foire aux questions',
                        internalTo: { path: '/help' },
                    },
                    {
                        label: 'Accès espace client',
                        internalTo: { name: 'login' },
                    },
                    {
                        label: 'Modes de livraison',
                        internalTo: { name: 'delivery-modes' },
                    },
                    {
                        label: 'Modes de paiement',
                        internalTo: { name: 'payment-modes' },
                    },
                ],
            },
            {
                title: 'Explorer nos gammes',
                links: [],
                customFeature: 'categoriesList',
            },
            {
                title: "Besoin d'une information ?",
                links: [
                    {
                        label: 'Nous contacter',
                        hubspotForm: {
                            name: 'contactUs',
                            formId: 'a370cba5-c60b-4888-affb-44fdfb7aeca6',
                            portalId: '5942000',
                            region: "eu1",
                        }
                    },
                ],
            },
        ],
    },
    pdp: {
        templateB2AGFeature: true,
        showOnlyMainImage: false,
        showSupplier: true,
        showSupplierUniverseLink: true,
        showBenefits: true,
        showCarouselSupplier: true
    },
    checkoutV2: {
        displayRpd: true,
        displayMention: true,
        selectionByProducts: true,
    }
};
//# sourceMappingURL=aladin.js.map